import { ComposeEditorType } from 'owa-mail-preferred-editor';
import { observer } from 'mobx-react';
import { Toggle } from 'office-ui-fabric-react/lib/components/Toggle';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { runInAction } from 'mobx';
import { ControlIcons } from 'owa-control-icons';
import * as React from 'react';
import { CompositeEditorViewState } from '../store/schema/CompositeEditorViewState';
import setPreferredEditorType from '../actions/setPreferredEditorType';
import updateContent from '../actions/updateContent';

const styles = require('./PreferredEditorToggle.scss');
const classNames = require('classnames/bind').bind(styles);

export interface PreferredEditorToggleProps {
    viewState: CompositeEditorViewState;
    getEditorContentFromDom: () => string;
}

// Since this component should only be mounted in SDF, I'm not pushing localizing this.
const tooltipText =
    'An SDF-only debugging toggle for downgrading to an HTML message from Rooster ' +
    'to a raw contenteditable div. If you are experiencing slow typing, try ' +
    'toggling this and see if the slow typing still repros. If it does not, ' +
    'then the slowdown may be caused by Compose event handlers.';

@observer
export default class PreferredEditorToggle extends React.Component<PreferredEditorToggleProps> {
    private onToggleChange = (event: React.MouseEvent<HTMLElement>, checked?: boolean) => {
        const currentDomContent = this.props.getEditorContentFromDom();
        runInAction('switch_editor_type', () => {
            updateContent(
                this.props.viewState,
                currentDomContent,
                // only mark dirty if it was already dirty
                this.props.viewState.isDirty /* isInitializing */
            );

            setPreferredEditorType(
                this.props.viewState,
                'HTML',
                checked
                    ? ComposeEditorType.RawContentEditableDivHTML
                    : ComposeEditorType.RoosterHTML
            );
        });
    };

    render() {
        const { preferredEditors, bodyType } = this.props.viewState;
        let disabled = bodyType !== 'HTML';
        let checked = preferredEditors['HTML'] === ComposeEditorType.RawContentEditableDivHTML;
        return (
            <div className={styles.preferredEditorToggle}>
                <TooltipHost content={tooltipText}>
                    <Icon className={styles.tooltipIcon} iconName={ControlIcons.Info} />
                </TooltipHost>
                <span
                    className={classNames({
                        toggleSymbol: true,
                        active: !checked,
                    })}>
                    🐓
                </span>
                <Toggle
                    className={styles.toggle}
                    disabled={disabled}
                    defaultChecked={checked}
                    onChange={this.onToggleChange}
                />
                <span
                    className={classNames({
                        toggleSymbol: true,
                        active: checked,
                    })}>
                    🐇
                </span>
            </div>
        );
    }
}
